

// // // import React, { useState } from 'react';
// // // import { createPortal } from 'react-dom';  // ✅ AJOUT
// // // import {
// // //   DndContext,
// // //   DragOverlay,
// // //   closestCenter,
// // //   PointerSensor,
// // //   useSensor,
// // //   useSensors,
// // // } from '@dnd-kit/core';
// // // import { useDraggable, useDroppable } from '@dnd-kit/core';

// // // // ==================== STYLES COMPLETS (inchangés) ====================
// // // const styles = {
// // //   container: {
// // //     maxWidth: '1400px',
// // //     margin: '20px auto',
// // //     padding: '25px',
// // //     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
// // //     borderRadius: '16px',
// // //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// // //   },
// // //   header: {
// // //     marginBottom: '25px',
// // //     textAlign: 'center',
// // //   },
// // //   title: {
// // //     color: '#1976d2',
// // //     fontSize: '24px',
// // //     marginBottom: '10px',
// // //     fontWeight: 'bold',
// // //   },
// // //   instruction: {
// // //     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
// // //     padding: '12px 18px',
// // //     borderRadius: '10px',
// // //     color: '#0d47a1',
// // //     fontSize: '14px',
// // //     borderLeft: '5px solid #1976d2',
// // //     display: 'inline-block',
// // //     boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
// // //   },
// // //   mainLayout: {
// // //     display: 'grid',
// // //     gridTemplateColumns: '1fr 1fr',
// // //     gap: '25px',
// // //     minHeight: '500px',
// // //   },
// // //   zonesContainer: {
// // //     background: 'white',
// // //     padding: '20px',
// // //     borderRadius: '12px',
// // //     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
// // //     border: '2px solid #e3f2fd',
// // //   },
// // //   zonesTitle: {
// // //     fontSize: '18px',
// // //     fontWeight: '700',
// // //     color: '#1976d2',
// // //     marginBottom: '20px',
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     gap: '10px',
// // //     borderBottom: '2px solid #e3f2fd',
// // //     paddingBottom: '10px',
// // //   },
// // //   zoneRow: {
// // //     marginBottom: '15px',
// // //     transition: 'transform 0.2s ease',
// // //   },
// // //   zoneLabel: {
// // //     fontSize: '14px',
// // //     fontWeight: '700',
// // //     color: 'white',
// // //     padding: '10px 15px',
// // //     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// // //     borderRadius: '8px',
// // //     marginBottom: '8px',
// // //     textAlign: 'center',
// // //     boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
// // //   },
// // //   dropZone: {
// // //     minHeight: '60px',
// // //     padding: '15px',
// // //     border: '3px dashed #cbd5e0',
// // //     borderRadius: '10px',
// // //     background: 'linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)',
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     justifyContent: 'center',
// // //     fontSize: '13px',
// // //     color: '#a0aec0',
// // //     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// // //     position: 'relative',
// // //     textAlign: 'center',
// // //   },
// // //   dropZoneActive: {
// // //     borderColor: '#1976d2',
// // //     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
// // //     transform: 'scale(1.02)',
// // //     boxShadow: '0 8px 25px rgba(25, 118, 210, 0.25)',
// // //   },
// // //   dropZoneFilled: {
// // //     border: '3px solid #1976d2',
// // //     background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
// // //     color: '#1565c0',
// // //     fontWeight: '600',
// // //     boxShadow: '0 4px 15px rgba(25, 118, 210, 0.2)',
// // //   },
// // //   dropZoneCorrect: {
// // //     border: '3px solid #4caf50',
// // //     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
// // //     color: '#2e7d32',
// // //     boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.15)',
// // //   },
// // //   dropZoneIncorrect: {
// // //     border: '3px solid #f44336',
// // //     background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
// // //     color: '#c62828',
// // //     boxShadow: '0 0 0 4px rgba(244, 67, 54, 0.15)',
// // //   },
// // //   propositionsContainer: {
// // //     background: 'white',
// // //     padding: '20px',
// // //     borderRadius: '12px',
// // //     border: '2px solid #e0e7ff',
// // //     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
// // //     display: 'flex',
// // //     flexDirection: 'column',
// // //   },
// // //   propositionsTitle: {
// // //     fontSize: '18px',
// // //     fontWeight: '700',
// // //     color: '#1976d2',
// // //     marginBottom: '20px',
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     gap: '10px',
// // //     borderBottom: '2px solid #e0e7ff',
// // //     paddingBottom: '10px',
// // //   },
// // //   propositionsGrid: {
// // //     display: 'grid',
// // //     gridTemplateColumns: '1fr',
// // //     gap: '12px',
// // //     overflowY: 'auto',
// // //     maxHeight: '550px',
// // //     paddingRight: '8px',
// // //   },
// // //   draggableItem: {
// // //     padding: '15px 18px',
// // //     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
// // //     border: '2px solid #e0e0e0',
// // //     borderRadius: '10px',
// // //     cursor: 'grab',
// // //     fontSize: '14px',
// // //     textAlign: 'center',
// // //     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// // //     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
// // //     fontWeight: '500',
// // //     color: '#2c3e50',
// // //   },
// // //   draggableItemHover: {
// // //     transform: 'translateX(5px)',
// // //     boxShadow: '0 6px 20px rgba(25, 118, 210, 0.25)',
// // //     borderColor: '#1976d2',
// // //   },
// // //   draggableItemUsed: {
// // //     opacity: 0.4,
// // //     cursor: 'not-allowed',
// // //     background: '#f5f5f5',
// // //     transform: 'scale(0.98)',
// // //   },
// // //   buttonContainer: {
// // //     display: 'flex',
// // //     justifyContent: 'center',
// // //     gap: '15px',
// // //     marginTop: '20px',
// // //   },
// // //   button: {
// // //     padding: '12px 28px',
// // //     border: 'none',
// // //     borderRadius: '10px',
// // //     fontSize: '15px',
// // //     fontWeight: '700',
// // //     cursor: 'pointer',
// // //     transition: 'all 0.3s ease',
// // //     boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
// // //   },
// // //   buttonDanger: {
// // //     background: 'linear-gradient(135deg, #f44336 0%, #e91e63 100%)',
// // //     color: 'white',
// // //   },
// // //   scoreDisplay: {
// // //     marginTop: '20px',
// // //     padding: '18px',
// // //     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// // //     borderRadius: '12px',
// // //     textAlign: 'center',
// // //     fontSize: '18px',
// // //     fontWeight: '700',
// // //     color: 'white',
// // //     boxShadow: '0 6px 20px rgba(102, 126, 234, 0.3)',
// // //   },
// // //   correctIcon: {
// // //     display: 'inline-block',
// // //     width: '22px',
// // //     height: '22px',
// // //     borderRadius: '50%',
// // //     background: '#4caf50',
// // //     color: 'white',
// // //     textAlign: 'center',
// // //     lineHeight: '22px',
// // //     fontSize: '12px',
// // //     fontWeight: 'bold',
// // //     position: 'absolute',
// // //     right: '8px',
// // //     top: '50%',
// // //     transform: 'translateY(-50%)',
// // //   },
// // //   incorrectIcon: {
// // //     display: 'inline-block',
// // //     width: '22px',
// // //     height: '22px',
// // //     borderRadius: '50%',
// // //     background: '#f44336',
// // //     color: 'white',
// // //     textAlign: 'center',
// // //     lineHeight: '22px',
// // //     fontSize: '12px',
// // //     fontWeight: 'bold',
// // //     position: 'absolute',
// // //     right: '8px',
// // //     top: '50%',
// // //     transform: 'translateY(-50%)',
// // //   },
// // //   correctAnswerBox: {
// // //     marginTop: '8px',
// // //     padding: '10px 12px',
// // //     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
// // //     border: '2px solid #4caf50',
// // //     borderRadius: '8px',
// // //     fontSize: '13px',
// // //     color: '#2e7d32',
// // //     fontWeight: '600',
// // //     display: 'flex',
// // //     alignItems: 'center',
// // //     gap: '8px',
// // //   },
// // // };

// // // // ==================== COMPOSANT DRAGGABLE ====================
// // // const DraggableProposition = ({ id, content, isUsed }) => {
// // //   const [isHovered, setIsHovered] = useState(false);
// // //   const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
// // //     id,
// // //     disabled: isUsed,
// // //   });

// // //   const style = {
// // //     ...styles.draggableItem,
// // //     ...(isUsed ? styles.draggableItemUsed : {}),
// // //     ...(isHovered && !isUsed ? styles.draggableItemHover : {}),
// // //     transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
// // //     opacity: isDragging ? 0.5 : 1,
// // //     cursor: isUsed ? 'not-allowed' : (isDragging ? 'grabbing' : 'grab'),
// // //   };

// // //   return (
// // //     <div
// // //       ref={setNodeRef}
// // //       style={style}
// // //       {...listeners}
// // //       {...attributes}
// // //       onMouseEnter={() => setIsHovered(true)}
// // //       onMouseLeave={() => setIsHovered(false)}
// // //     >
// // //       {isUsed && <span style={{ marginRight: '8px', color: '#4caf50' }}>✓</span>}
// // //       {content}
// // //     </div>
// // //   );
// // // };

// // // // ==================== COMPOSANT DROP ZONE ====================
// // // const DropZone = ({ id, label, filledWith, correctAnswer, isCorrect, showAnswers }) => {
// // //   const { setNodeRef, isOver } = useDroppable({ id });

// // //   let zoneStyle = { ...styles.dropZone };

// // //   if (isOver) {
// // //     zoneStyle = { ...zoneStyle, ...styles.dropZoneActive };
// // //   }

// // //   if (filledWith) {
// // //     zoneStyle = { ...zoneStyle, ...styles.dropZoneFilled };

// // //     if (showAnswers) {
// // //       if (isCorrect) {
// // //         zoneStyle = { ...zoneStyle, ...styles.dropZoneCorrect };
// // //       } else {
// // //         zoneStyle = { ...zoneStyle, ...styles.dropZoneIncorrect };
// // //       }
// // //     }
// // //   }

// // //   return (
// // //     <div style={styles.zoneRow}>
// // //       <div style={styles.zoneLabel}>{label}</div>
// // //       <div>
// // //         <div ref={setNodeRef} style={zoneStyle}>
// // //           {filledWith || '⤵ Glissez ici'}
// // //           {showAnswers && filledWith && (
// // //             <span style={isCorrect ? styles.correctIcon : styles.incorrectIcon}>
// // //               {isCorrect ? '✓' : '✗'}
// // //             </span>
// // //           )}
// // //         </div>

// // //         {showAnswers && !isCorrect && filledWith && (
// // //           <div style={styles.correctAnswerBox}>
// // //             <span style={{ fontSize: '16px' }}>💡</span>
// // //             <span>Réponse attendue : <strong>{correctAnswer}</strong></span>
// // //           </div>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ==================== COMPOSANT PRINCIPAL ====================
// // // const DragDropZones = ({
// // //   zones,
// // //   propositions,
// // //   onAnswerChange,
// // //   showCorrectAnswers = false,
// // //   initialFilledZones = {},
// // // }) => {
// // //   const [filledZones, setFilledZones] = useState(initialFilledZones);
// // //   const [activeId, setActiveId] = useState(null);

// // //   const sensors = useSensors(
// // //     useSensor(PointerSensor, {
// // //       activationConstraint: {
// // //         distance: 8,
// // //       },
// // //     })
// // //   );

// // //   const handleDragStart = (event) => {
// // //     setActiveId(event.active.id);
// // //     document.body.style.cursor = 'grabbing';  // ✅ Force curseur
// // //   };

// // //   const handleDragEnd = (event) => {
// // //     const { active, over } = event;

// // //     if (over) {
// // //       const proposition = propositions.find((p) => p.id === active.id);

// // //       setFilledZones((prev) => ({
// // //         ...prev,
// // //         [over.id]: proposition.content,
// // //       }));

// // //       if (onAnswerChange) {
// // //         onAnswerChange({
// // //           zoneId: over.id,
// // //           content: proposition.content,
// // //         });
// // //       }
// // //     }

// // //     document.body.style.cursor = '';  // ✅ Restaure curseur
// // //     setActiveId(null);
// // //   };

// // //   const handleReset = () => {
// // //     setFilledZones({});
// // //   };

// // //   const calculateScore = () => {
// // //     let correct = 0;
// // //     zones.forEach((zone) => {
// // //       if (filledZones[zone.id] === zone.correctAnswer) {
// // //         correct++;
// // //       }
// // //     });
// // //     return {
// // //       correct,
// // //       total: zones.length,
// // //       percentage: (correct / zones.length) * 100,
// // //     };
// // //   };

// // //   const usedPropositions = Object.values(filledZones);
// // //   const score = calculateScore();
// // //   const activeProposition = propositions.find((p) => p.id === activeId);

// // //   return (
// // //     <div style={styles.container}>
// // //       <div style={styles.header}>
// // //         <h3 style={styles.title}>🎯 Question de correspondance</h3>
// // //         <p style={styles.instruction}>
// // //           📌 Glissez les propositions de droite vers les zones de gauche
// // //         </p>
// // //       </div>

// // //       <DndContext
// // //         sensors={sensors}
// // //         collisionDetection={closestCenter}
// // //         onDragStart={handleDragStart}
// // //         onDragEnd={handleDragEnd}
// // //       >
// // //         <div style={styles.mainLayout}>
// // //           <div style={styles.zonesContainer}>
// // //             <div style={styles.zonesTitle}>
// // //               <span>🎯</span>
// // //               <span>Zones à remplir</span>
// // //             </div>

// // //             {zones.map((zone) => (
// // //               <DropZone
// // //                 key={zone.id}
// // //                 id={zone.id}
// // //                 label={zone.label}
// // //                 filledWith={filledZones[zone.id]}
// // //                 correctAnswer={zone.correctAnswer}
// // //                 isCorrect={filledZones[zone.id] === zone.correctAnswer}
// // //                 showAnswers={showCorrectAnswers}
// // //               />
// // //             ))}
// // //           </div>

// // //           <div style={styles.propositionsContainer}>
// // //             <div style={styles.propositionsTitle}>
// // //               <span>📦</span>
// // //               <span>Propositions disponibles</span>
// // //             </div>

// // //             <div style={styles.propositionsGrid}>
// // //               {propositions.map((prop) => (
// // //                 <DraggableProposition
// // //                   key={prop.id}
// // //                   id={prop.id}
// // //                   content={prop.content}
// // //                   isUsed={usedPropositions.includes(prop.content)}
// // //                 />
// // //               ))}
// // //             </div>
// // //           </div>
// // //         </div>

// // //         {/* ✅ SOLUTION : Portal vers body */}
// // //         {createPortal(
// // //           <DragOverlay dropAnimation={null}>
// // //             {activeProposition ? (
// // //               <div style={{
// // //                 ...styles.draggableItem,
// // //                 cursor: 'grabbing',
// // //                 opacity: 0.95,
// // //                 transform: 'rotate(2deg)',
// // //                 boxShadow: '0 15px 40px rgba(0, 0, 0, 0.4)',
// // //                 pointerEvents: 'none',
// // //                 zIndex: 99999,
// // //               }}>
// // //                 {activeProposition.content}
// // //               </div>
// // //             ) : null}
// // //           </DragOverlay>,
// // //           document.body
// // //         )}
// // //       </DndContext>

// // //       <div style={styles.buttonContainer}>
// // //         <button
// // //           style={{ ...styles.button, ...styles.buttonDanger }}
// // //           onClick={handleReset}
// // //           onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
// // //           onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
// // //         >
// // //           🔄 Recommencer
// // //         </button>
// // //       </div>

// // //       {showCorrectAnswers && (
// // //         <div style={styles.scoreDisplay}>
// // //           {score.percentage === 100 ? '🎉' : '📊'} Score : {score.correct} / {score.total} ({score.percentage.toFixed(0)}%)
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default DragDropZones;






// // import React, { useState } from 'react';
// // import { createPortal } from 'react-dom';  // ✅ AJOUT
// // import {
// //   DndContext,
// //   DragOverlay,
// //   closestCenter,
// //   PointerSensor,
// //   useSensor,
// //   useSensors,
// // } from '@dnd-kit/core';
// // import { useDraggable, useDroppable } from '@dnd-kit/core';

// // // ==================== STYLES COMPLETS (inchangés) ====================
// // const styles = {
// //   container: {
// //     maxWidth: '1400px',
// //     margin: '20px auto',
// //     padding: '25px',
// //     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
// //     borderRadius: '16px',
// //     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
// //   },
// //   header: {
// //     marginBottom: '25px',
// //     textAlign: 'center',
// //   },
// //   title: {
// //     color: '#1976d2',
// //     fontSize: '24px',
// //     marginBottom: '10px',
// //     fontWeight: 'bold',
// //   },
// //   instruction: {
// //     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
// //     padding: '12px 18px',
// //     borderRadius: '10px',
// //     color: '#0d47a1',
// //     fontSize: '14px',
// //     borderLeft: '5px solid #1976d2',
// //     display: 'inline-block',
// //     boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
// //   },
// //   mainLayout: {
// //   display: 'flex',           // ✅ Changé de 'grid' à 'flex'
// //   flexDirection: 'column',   // ✅ Direction verticale
// //   gap: '25px',
// //   minHeight: '500px',
// // },
// //   zonesContainer: {
// //     background: 'white',
// //     padding: '20px',
// //     borderRadius: '12px',
// //     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
// //     border: '2px solid #e3f2fd',
// //       minHeight: '300px',  // ✅ Ajuster selon vos besoins

// //   },
// //   zonesTitle: {
// //     fontSize: '18px',
// //     fontWeight: '700',
// //     color: '#1976d2',
// //     marginBottom: '20px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '10px',
// //     borderBottom: '2px solid #e3f2fd',
// //     paddingBottom: '10px',
// //   },
// //   zoneRow: {
// //     marginBottom: '15px',
// //     transition: 'transform 0.2s ease',
// //   },
// //   zoneLabel: {
// //     fontSize: '14px',
// //     fontWeight: '700',
// //     color: 'white',
// //     padding: '10px 15px',
// //     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //     borderRadius: '8px',
// //     marginBottom: '8px',
// //     textAlign: 'center',
// //     boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
// //   },
// //   dropZone: {
// //     minHeight: '60px',
// //     padding: '15px',
// //     border: '3px dashed #cbd5e0',
// //     borderRadius: '10px',
// //     background: 'linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     fontSize: '13px',
// //     color: '#a0aec0',
// //     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //     position: 'relative',
// //     textAlign: 'center',
// //   },
// //   dropZoneActive: {
// //     borderColor: '#1976d2',
// //     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
// //     transform: 'scale(1.02)',
// //     boxShadow: '0 8px 25px rgba(25, 118, 210, 0.25)',
// //   },
// //   dropZoneFilled: {
// //     border: '3px solid #1976d2',
// //     background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
// //     color: '#1565c0',
// //     fontWeight: '600',
// //     boxShadow: '0 4px 15px rgba(25, 118, 210, 0.2)',
// //   },
// //   dropZoneCorrect: {
// //     border: '3px solid #4caf50',
// //     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
// //     color: '#2e7d32',
// //     boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.15)',
// //   },
// //   dropZoneIncorrect: {
// //     border: '3px solid #f44336',
// //     background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
// //     color: '#c62828',
// //     boxShadow: '0 0 0 4px rgba(244, 67, 54, 0.15)',
// //   },
// //   propositionsContainer: {
// //     background: 'white',
// //     padding: '20px',
// //     borderRadius: '12px',
// //     border: '2px solid #e0e7ff',
// //     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
// //     display: 'flex',
// //     flexDirection: 'column',
// //   },
// //   propositionsTitle: {
// //     fontSize: '18px',
// //     fontWeight: '700',
// //     color: '#1976d2',
// //     marginBottom: '20px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '10px',
// //     borderBottom: '2px solid #e0e7ff',
// //     paddingBottom: '10px',
// //   },
  
// //  draggableItem: {
// //   padding: '12px 18px',         // ✅ Padding réduit
// //   background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
// //   border: '2px solid #1976d2',  // ✅ Bordure bleue
// //   borderRadius: '10px',
// //   cursor: 'grab',
// //   fontSize: '14px',
// //   textAlign: 'center',
// //   transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
// //   boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',  // ✅ Ombre bleue
// //   fontWeight: '600',            // ✅ Plus gras
// //   color: '#1976d2',             // ✅ Texte bleu
// //   minWidth: '140px',            // ✅ Largeur minimum
// //   whiteSpace: 'nowrap',         // ✅ Pas de retour à la ligne dans le texte
// // },
// //   draggableItemHover: {
// //     transform: 'translateX(5px)',
// //     boxShadow: '0 6px 20px rgba(25, 118, 210, 0.25)',
// //     borderColor: '#1976d2',
// //   },
// //   draggableItemUsed: {
// //     opacity: 0.4,
// //     cursor: 'not-allowed',
// //     background: '#f5f5f5',
// //     transform: 'scale(0.98)',
// //   },
// //   buttonContainer: {
// //     display: 'flex',
// //     justifyContent: 'center',
// //     gap: '15px',
// //     marginTop: '20px',
// //   },
// //   button: {
// //     padding: '12px 28px',
// //     border: 'none',
// //     borderRadius: '10px',
// //     fontSize: '15px',
// //     fontWeight: '700',
// //     cursor: 'pointer',
// //     transition: 'all 0.3s ease',
// //     boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
// //   },
// //   buttonDanger: {
// //     background: 'linear-gradient(135deg, #f44336 0%, #e91e63 100%)',
// //     color: 'white',
// //   },
// //   scoreDisplay: {
// //     marginTop: '20px',
// //     padding: '18px',
// //     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
// //     borderRadius: '12px',
// //     textAlign: 'center',
// //     fontSize: '18px',
// //     fontWeight: '700',
// //     color: 'white',
// //     boxShadow: '0 6px 20px rgba(102, 126, 234, 0.3)',
// //   },
// //   correctIcon: {
// //     display: 'inline-block',
// //     width: '22px',
// //     height: '22px',
// //     borderRadius: '50%',
// //     background: '#4caf50',
// //     color: 'white',
// //     textAlign: 'center',
// //     lineHeight: '22px',
// //     fontSize: '12px',
// //     fontWeight: 'bold',
// //     position: 'absolute',
// //     right: '8px',
// //     top: '50%',
// //     transform: 'translateY(-50%)',
// //   },
// //   incorrectIcon: {
// //     display: 'inline-block',
// //     width: '22px',
// //     height: '22px',
// //     borderRadius: '50%',
// //     background: '#f44336',
// //     color: 'white',
// //     textAlign: 'center',
// //     lineHeight: '22px',
// //     fontSize: '12px',
// //     fontWeight: 'bold',
// //     position: 'absolute',
// //     right: '8px',
// //     top: '50%',
// //     transform: 'translateY(-50%)',
// //   },
// //   correctAnswerBox: {
// //     marginTop: '8px',
// //     padding: '10px 12px',
// //     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
// //     border: '2px solid #4caf50',
// //     borderRadius: '8px',
// //     fontSize: '13px',
// //     color: '#2e7d32',
// //     fontWeight: '600',
// //     display: 'flex',
// //     alignItems: 'center',
// //     gap: '8px',
// //   },
// // };

// // // ==================== COMPOSANT DRAGGABLE ====================
// // const DraggableProposition = ({ id, content, isUsed }) => {
// //   const [isHovered, setIsHovered] = useState(false);
// //   const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
// //     id,
// //     disabled: isUsed,
// //   });

// //   const style = {
// //     ...styles.draggableItem,
// //     ...(isUsed ? styles.draggableItemUsed : {}),
// //     ...(isHovered && !isUsed ? styles.draggableItemHover : {}),
// //     transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
// //     opacity: isDragging ? 0.5 : 1,
// //     cursor: isUsed ? 'not-allowed' : (isDragging ? 'grabbing' : 'grab'),
// //   };

// //   return (
// //     <div
// //       ref={setNodeRef}
// //       style={style}
// //       {...listeners}
// //       {...attributes}
// //       onMouseEnter={() => setIsHovered(true)}
// //       onMouseLeave={() => setIsHovered(false)}
// //     >
// //       {isUsed && <span style={{ marginRight: '8px', color: '#4caf50' }}>✓</span>}
// //       {content}
// //     </div>
// //   );
// // };

// // // ==================== COMPOSANT DROP ZONE ====================
// // const DropZone = ({ id, label, filledWith, correctAnswer, isCorrect, showAnswers }) => {
// //   const { setNodeRef, isOver } = useDroppable({ id });

// //   let zoneStyle = { ...styles.dropZone };

// //   if (isOver) {
// //     zoneStyle = { ...zoneStyle, ...styles.dropZoneActive };
// //   }

// //   if (filledWith) {
// //     zoneStyle = { ...zoneStyle, ...styles.dropZoneFilled };

// //     if (showAnswers) {
// //       if (isCorrect) {
// //         zoneStyle = { ...zoneStyle, ...styles.dropZoneCorrect };
// //       } else {
// //         zoneStyle = { ...zoneStyle, ...styles.dropZoneIncorrect };
// //       }
// //     }
// //   }

// //   return (
// //     <div style={styles.zoneRow}>
// //       <div style={styles.zoneLabel}>{label}</div>
// //       <div>
// //         <div ref={setNodeRef} style={zoneStyle}>
// //           {filledWith || '⤵ Glissez ici'}
// //           {showAnswers && filledWith && (
// //             <span style={isCorrect ? styles.correctIcon : styles.incorrectIcon}>
// //               {isCorrect ? '✓' : '✗'}
// //             </span>
// //           )}
// //         </div>

// //         {showAnswers && !isCorrect && filledWith && (
// //           <div style={styles.correctAnswerBox}>
// //             <span style={{ fontSize: '16px' }}>💡</span>
// //             <span>Réponse attendue : <strong>{correctAnswer}</strong></span>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // // ==================== COMPOSANT PRINCIPAL ====================
// // const DragDropZones = ({
// //   zones,
// //   propositions,
// //   onAnswerChange,
// //   showCorrectAnswers = false,
// //   initialFilledZones = {},
// // }) => {
// //   const [filledZones, setFilledZones] = useState(initialFilledZones);
// //   const [activeId, setActiveId] = useState(null);

// //   const sensors = useSensors(
// //     useSensor(PointerSensor, {
// //       activationConstraint: {
// //         distance: 8,
// //       },
// //     })
// //   );

// //   const handleDragStart = (event) => {
// //     setActiveId(event.active.id);
// //     document.body.style.cursor = 'grabbing';  // ✅ Force curseur
// //   };

// //   const handleDragEnd = (event) => {
// //     const { active, over } = event;

// //     if (over) {
// //       const proposition = propositions.find((p) => p.id === active.id);

// //       setFilledZones((prev) => ({
// //         ...prev,
// //         [over.id]: proposition.content,
// //       }));

// //       if (onAnswerChange) {
// //         onAnswerChange({
// //           zoneId: over.id,
// //           content: proposition.content,
// //         });
// //       }
// //     }

// //     document.body.style.cursor = '';  // ✅ Restaure curseur
// //     setActiveId(null);
// //   };

// //   const handleReset = () => {
// //     setFilledZones({});
// //   };

// //   const calculateScore = () => {
// //     let correct = 0;
// //     zones.forEach((zone) => {
// //       if (filledZones[zone.id] === zone.correctAnswer) {
// //         correct++;
// //       }
// //     });
// //     return {
// //       correct,
// //       total: zones.length,
// //       percentage: (correct / zones.length) * 100,
// //     };
// //   };

// //   const usedPropositions = Object.values(filledZones);
// //   const score = calculateScore();
// //   const activeProposition = propositions.find((p) => p.id === activeId);

// //   return (
// //     <div style={styles.container}>
// //       <div style={styles.header}>
// //         <h3 style={styles.title}>🎯 Question de correspondance</h3>
// //         <p style={styles.instruction}>
// //           📌 Glissez les propositions de droite vers les zones de gauche
// //         </p>
// //       </div>

// //       <DndContext
// //         sensors={sensors}
// //         collisionDetection={closestCenter}
// //         onDragStart={handleDragStart}
// //         onDragEnd={handleDragEnd}
// //       >
// //       <div style={styles.mainLayout}>
// //   {/* ✅ 1. ZONES EN HAUT */}
// //   <div style={styles.zonesContainer}>
// //     <div style={styles.zonesTitle}>
// //       <span>🎯</span>
// //       <span>Zones à remplir</span>
// //     </div>

// //     {zones.map((zone) => (
// //       <DropZone
// //         key={zone.id}
// //         id={zone.id}
// //         label={zone.label}
// //         filledWith={filledZones[zone.id]}
// //         correctAnswer={zone.correctAnswer}
// //         isCorrect={filledZones[zone.id] === zone.correctAnswer}
// //         showAnswers={showCorrectAnswers}
// //       />
// //     ))}
// //   </div>

// //   {/* ✅ 2. PROPOSITIONS EN BAS */}
// //   <div style={styles.propositionsContainer}>
// //     <div style={styles.propositionsTitle}>
// //       <span>🎲</span>
// //       <span>Propositions disponibles</span>
// //     </div>

// //     <div style={styles.propositionsGrid}>
// //       {propositions.map((prop) => (
// //         <DraggableProposition
// //           key={prop.id}
// //           id={prop.id}
// //           content={prop.content}
// //           isUsed={usedPropositions.includes(prop.content)}
// //         />
// //       ))}
// //     </div>
// //   </div>
// // </div>

// //         {/* ✅ SOLUTION : Portal vers body */}
// //         {createPortal(
// //           <DragOverlay dropAnimation={null}>
// //             {activeProposition ? (
// //               <div style={{
// //                 ...styles.draggableItem,
// //                 cursor: 'grabbing',
// //                 opacity: 0.95,
// //                 transform: 'rotate(2deg)',
// //                 boxShadow: '0 15px 40px rgba(0, 0, 0, 0.4)',
// //                 pointerEvents: 'none',
// //                 zIndex: 99999,
// //               }}>
// //                 {activeProposition.content}
// //               </div>
// //             ) : null}
// //           </DragOverlay>,
// //           document.body
// //         )}
// //       </DndContext>

// //       <div style={styles.buttonContainer}>
// //         <button
// //           style={{ ...styles.button, ...styles.buttonDanger }}
// //           onClick={handleReset}
// //           onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
// //           onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
// //         >
// //           🔄 Recommencer
// //         </button>
// //       </div>

// //       {showCorrectAnswers && (
// //         <div style={styles.scoreDisplay}>
// //           {score.percentage === 100 ? '🎉' : '📊'} Score : {score.correct} / {score.total} ({score.percentage.toFixed(0)}%)
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default DragDropZones;





// import React, { useState } from 'react';
// import { createPortal } from 'react-dom';
// import {
//   DndContext,
//   DragOverlay,
//   closestCenter,
//   PointerSensor,
//   useSensor,
//   useSensors,
// } from '@dnd-kit/core';
// import { useDraggable, useDroppable } from '@dnd-kit/core';

// // ==================== STYLES COMPLETS ====================
// const styles = {
//   container: {
//     maxWidth: '1400px',
//     margin: '20px auto',
//     padding: '25px',
//     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//     borderRadius: '16px',
//     boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
//   },
//   header: {
//     marginBottom: '25px',
//     textAlign: 'center',
//   },
//   title: {
//     color: '#1976d2',
//     fontSize: '24px',
//     marginBottom: '10px',
//     fontWeight: 'bold',
//   },
//   instruction: {
//     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
//     padding: '12px 18px',
//     borderRadius: '10px',
//     color: '#0d47a1',
//     fontSize: '14px',
//     borderLeft: '5px solid #1976d2',
//     display: 'inline-block',
//     boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
//   },
//   mainLayout: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '25px',
//     minHeight: '500px',
//   },
//   zonesContainer: {
//     background: 'white',
//     padding: '20px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//     border: '2px solid #e3f2fd',
//     minHeight: '300px',
//   },
//   zonesTitle: {
//     fontSize: '18px',
//     fontWeight: '700',
//     color: '#1976d2',
//     marginBottom: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     borderBottom: '2px solid #e3f2fd',
//     paddingBottom: '10px',
//   },
//   zoneRow: {
//     marginBottom: '15px',
//     transition: 'transform 0.2s ease',
//   },
//   zoneLabel: {
//     fontSize: '14px',
//     fontWeight: '700',
//     color: 'white',
//     padding: '10px 15px',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     borderRadius: '8px',
//     marginBottom: '8px',
//     textAlign: 'center',
//     boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
//   },
//   dropZone: {
//     minHeight: '60px',
//     padding: '15px',
//     border: '3px dashed #cbd5e0',
//     borderRadius: '10px',
//     background: 'linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '13px',
//     color: '#a0aec0',
//     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//     position: 'relative',
//     textAlign: 'center',
//   },
//   dropZoneActive: {
//     borderColor: '#1976d2',
//     background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
//     transform: 'scale(1.02)',
//     boxShadow: '0 8px 25px rgba(25, 118, 210, 0.25)',
//   },
//   dropZoneFilled: {
//     border: '3px solid #1976d2',
//     background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
//     color: '#1565c0',
//     fontWeight: '600',
//     boxShadow: '0 4px 15px rgba(25, 118, 210, 0.2)',
//   },
//   dropZoneCorrect: {
//     border: '3px solid #4caf50',
//     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
//     color: '#2e7d32',
//     boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.15)',
//   },
//   dropZoneIncorrect: {
//     border: '3px solid #f44336',
//     background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
//     color: '#c62828',
//     boxShadow: '0 0 0 4px rgba(244, 67, 54, 0.15)',
//   },
//   propositionsContainer: {
//     background: 'white',
//     padding: '20px',
//     borderRadius: '12px',
//     border: '2px solid #e0e7ff',
//     boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   propositionsTitle: {
//     fontSize: '18px',
//     fontWeight: '700',
//     color: '#1976d2',
//     marginBottom: '20px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '10px',
//     borderBottom: '2px solid #e0e7ff',
//     paddingBottom: '10px',
//   },
//   propositionsGrid: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '12px',
//     overflowY: 'auto',
//     maxHeight: '200px',
//     paddingRight: '8px',
//     justifyContent: 'center',
//   },
//   draggableItem: {
//     padding: '12px 18px',
//     background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//     border: '2px solid #1976d2',
//     borderRadius: '10px',
//     cursor: 'grab',
//     fontSize: '14px',
//     textAlign: 'center',
//     transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//     boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
//     fontWeight: '600',
//     color: '#1976d2',
//     minWidth: '140px',
//     whiteSpace: 'nowrap',
//   },
//   draggableItemHover: {
//     transform: 'translateY(-3px)',
//     boxShadow: '0 6px 20px rgba(25, 118, 210, 0.3)',
//     borderColor: '#1565c0',
//   },
//   draggableItemUsed: {
//     opacity: 0.4,
//     cursor: 'not-allowed',
//     background: '#f5f5f5',
//     transform: 'scale(0.98)',
//   },
//   buttonContainer: {
//     display: 'flex',
//     justifyContent: 'center',
//     gap: '15px',
//     marginTop: '20px',
//   },
//   button: {
//     padding: '12px 28px',
//     border: 'none',
//     borderRadius: '10px',
//     fontSize: '15px',
//     fontWeight: '700',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
//   },
//   buttonDanger: {
//     background: 'linear-gradient(135deg, #f44336 0%, #e91e63 100%)',
//     color: 'white',
//   },
//   scoreDisplay: {
//     marginTop: '20px',
//     padding: '18px',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     borderRadius: '12px',
//     textAlign: 'center',
//     fontSize: '18px',
//     fontWeight: '700',
//     color: 'white',
//     boxShadow: '0 6px 20px rgba(102, 126, 234, 0.3)',
//   },
//   correctIcon: {
//     display: 'inline-block',
//     width: '22px',
//     height: '22px',
//     borderRadius: '50%',
//     background: '#4caf50',
//     color: 'white',
//     textAlign: 'center',
//     lineHeight: '22px',
//     fontSize: '12px',
//     fontWeight: 'bold',
//     position: 'absolute',
//     right: '8px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//   },
//   incorrectIcon: {
//     display: 'inline-block',
//     width: '22px',
//     height: '22px',
//     borderRadius: '50%',
//     background: '#f44336',
//     color: 'white',
//     textAlign: 'center',
//     lineHeight: '22px',
//     fontSize: '12px',
//     fontWeight: 'bold',
//     position: 'absolute',
//     right: '8px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//   },
//   correctAnswerBox: {
//     marginTop: '8px',
//     padding: '10px 12px',
//     background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
//     border: '2px solid #4caf50',
//     borderRadius: '8px',
//     fontSize: '13px',
//     color: '#2e7d32',
//     fontWeight: '600',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//   },
// };

// // ==================== COMPOSANT DRAGGABLE ====================
// const DraggableProposition = ({ id, content, isUsed }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
//     id,
//     disabled: isUsed,
//   });

//   const style = {
//     ...styles.draggableItem,
//     ...(isUsed ? styles.draggableItemUsed : {}),
//     ...(isHovered && !isUsed ? styles.draggableItemHover : {}),
//     transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
//     opacity: isDragging ? 0.5 : 1,
//     cursor: isUsed ? 'not-allowed' : (isDragging ? 'grabbing' : 'grab'),
//   };

//   return (
//     <div
//       ref={setNodeRef}
//       style={style}
//       {...listeners}
//       {...attributes}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {isUsed && <span style={{ marginRight: '8px', color: '#4caf50' }}>✓</span>}
//       💡 {content}
//     </div>
//   );
// };

// // ==================== COMPOSANT DROP ZONE ====================
// const DropZone = ({ id, label, filledWith, correctAnswer, isCorrect, showAnswers }) => {
//   const { setNodeRef, isOver } = useDroppable({ id });

//   let zoneStyle = { ...styles.dropZone };

//   if (isOver) {
//     zoneStyle = { ...zoneStyle, ...styles.dropZoneActive };
//   }

//   if (filledWith) {
//     zoneStyle = { ...zoneStyle, ...styles.dropZoneFilled };

//     if (showAnswers) {
//       if (isCorrect) {
//         zoneStyle = { ...zoneStyle, ...styles.dropZoneCorrect };
//       } else {
//         zoneStyle = { ...zoneStyle, ...styles.dropZoneIncorrect };
//       }
//     }
//   }

//   return (
//     <div style={styles.zoneRow}>
//       <div style={styles.zoneLabel}>📍 {label}</div>
//       <div>
//         <div ref={setNodeRef} style={zoneStyle}>
//           {filledWith ? `💡 ${filledWith}` : '📥 Glissez une proposition ici'}
//           {showAnswers && filledWith && (
//             <span style={isCorrect ? styles.correctIcon : styles.incorrectIcon}>
//               {isCorrect ? '✓' : '✗'}
//             </span>
//           )}
//         </div>

//         {showAnswers && !isCorrect && filledWith && (
//           <div style={styles.correctAnswerBox}>
//             <span style={{ fontSize: '16px' }}>💡</span>
//             <span>Réponse attendue : <strong>{correctAnswer}</strong></span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ==================== COMPOSANT PRINCIPAL ====================
// const DragDropZones = ({
//   zones,
//   propositions,
//   onAnswerChange,
//   showCorrectAnswers = false,
//   initialFilledZones = {},
// }) => {
//   const [filledZones, setFilledZones] = useState(initialFilledZones);
//   const [activeId, setActiveId] = useState(null);

//   const sensors = useSensors(
//     useSensor(PointerSensor, {
//       activationConstraint: {
//         distance: 8,
//       },
//     })
//   );

//   const handleDragStart = (event) => {
//     setActiveId(event.active.id);
//     document.body.style.cursor = 'grabbing';
//   };

//   const handleDragEnd = (event) => {
//     const { active, over } = event;

//     if (over) {
//       const proposition = propositions.find((p) => p.id === active.id);

//       setFilledZones((prev) => ({
//         ...prev,
//         [over.id]: proposition.content,
//       }));

//       if (onAnswerChange) {
//         onAnswerChange({
//           zoneId: over.id,
//           content: proposition.content,
//         });
//       }
//     }

//     document.body.style.cursor = '';
//     setActiveId(null);
//   };

//   const handleReset = () => {
//     setFilledZones({});
//   };

//   const calculateScore = () => {
//     let correct = 0;
//     zones.forEach((zone) => {
//       if (filledZones[zone.id] === zone.correctAnswer) {
//         correct++;
//       }
//     });
//     return {
//       correct,
//       total: zones.length,
//       percentage: (correct / zones.length) * 100,
//     };
//   };

//   const usedPropositions = Object.values(filledZones);
//   const score = calculateScore();
//   const activeProposition = propositions.find((p) => p.id === activeId);

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <h3 style={styles.title}>🎯 Question de correspondance</h3>
//         <p style={styles.instruction}>
//           📌 Glissez les propositions du bas vers les zones du haut
//         </p>
//       </div>

//       <DndContext
//         sensors={sensors}
//         collisionDetection={closestCenter}
//         onDragStart={handleDragStart}
//         onDragEnd={handleDragEnd}
//       >
//         <div style={styles.mainLayout}>
//           {/* ✅ 1. ZONES À REMPLIR (EN HAUT) */}
//           <div style={styles.zonesContainer}>
//             <div style={styles.zonesTitle}>
//               <span>🎯</span>
//               <span>Zones à remplir</span>
//             </div>

//             {zones.map((zone) => (
//               <DropZone
//                 key={zone.id}
//                 id={zone.id}
//                 label={zone.label}
//                 filledWith={filledZones[zone.id]}
//                 correctAnswer={zone.correctAnswer}
//                 isCorrect={filledZones[zone.id] === zone.correctAnswer}
//                 showAnswers={showCorrectAnswers}
//               />
//             ))}
//           </div>

//           {/* ✅ 2. PROPOSITIONS DISPONIBLES (EN BAS, HORIZONTAL) */}
//           <div style={styles.propositionsContainer}>
//             <div style={styles.propositionsTitle}>
//               <span>🎲</span>
//               <span>Propositions disponibles</span>
//             </div>

//             <div style={styles.propositionsGrid}>
//               {propositions.map((prop) => (
//                 <DraggableProposition
//                   key={prop.id}
//                   id={prop.id}
//                   content={prop.content}
//                   isUsed={usedPropositions.includes(prop.content)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Portal pour le DragOverlay */}
//         {createPortal(
//           <DragOverlay dropAnimation={null}>
//             {activeProposition ? (
//               <div style={{
//                 ...styles.draggableItem,
//                 cursor: 'grabbing',
//                 opacity: 0.95,
//                 transform: 'rotate(2deg)',
//                 boxShadow: '0 15px 40px rgba(0, 0, 0, 0.4)',
//                 pointerEvents: 'none',
//                 zIndex: 99999,
//               }}>
//                 💡 {activeProposition.content}
//               </div>
//             ) : null}
//           </DragOverlay>,
//           document.body
//         )}
//       </DndContext>

//       <div style={styles.buttonContainer}>
//         <button
//           style={{ ...styles.button, ...styles.buttonDanger }}
//           onClick={handleReset}
//           onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
//           onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
//         >
//           🔄 Recommencer
//         </button>
//       </div>

//       {showCorrectAnswers && (
//         <div style={styles.scoreDisplay}>
//           {score.percentage === 100 ? '🎉' : '📊'} Score : {score.correct} / {score.total} ({score.percentage.toFixed(0)}%)
//         </div>
//       )}
//     </div>
//   );
// };

// export default DragDropZones;




import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import {
  DndContext,
  DragOverlay,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { useDraggable, useDroppable } from '@dnd-kit/core';

// ==================== STYLES COMPLETS ====================
const styles = {
  container: {
    maxWidth: '1400px',
    margin: '20px auto',
    padding: '25px',
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  },
  header: {
    marginBottom: '25px',
    textAlign: 'center',
  },
  title: {
    color: '#1976d2',
    fontSize: '24px',
    marginBottom: '10px',
    fontWeight: 'bold',
  },
  instruction: {
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    padding: '12px 18px',
    borderRadius: '10px',
    color: '#0d47a1',
    fontSize: '14px',
    borderLeft: '5px solid #1976d2',
    display: 'inline-block',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
  },
  mainLayout: {
    display: 'flex',
    flexDirection: 'column',
    gap: '25px',
    minHeight: '400px',
  },
  zonesContainer: {
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    border: '2px solid #e3f2fd',
  },
  zonesTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1976d2',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderBottom: '2px solid #e3f2fd',
    paddingBottom: '10px',
  },
  zonesGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'center',
    minHeight: '100px',
  },
  zoneCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: '180px',
    maxWidth: '220px',
  },
  zoneLabel: {
    fontSize: '13px',
    fontWeight: '700',
    color: 'white',
    padding: '8px 12px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '8px',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
  },
  dropZone: {
    minHeight: '50px',
    padding: '10px 12px',
    border: '3px dashed #cbd5e0',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: '#a0aec0',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    textAlign: 'center',
  },
  dropZoneActive: {
    borderColor: '#1976d2',
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    transform: 'scale(1.05)',
    boxShadow: '0 8px 25px rgba(25, 118, 210, 0.25)',
  },
  dropZoneFilled: {
    border: '3px solid #1976d2',
    background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
    color: '#1565c0',
    fontWeight: '600',
    fontSize: '13px',
    boxShadow: '0 4px 15px rgba(25, 118, 210, 0.2)',
  },
  dropZoneCorrect: {
    border: '3px solid #4caf50',
    background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
    color: '#2e7d32',
    boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.15)',
  },
  dropZoneIncorrect: {
    border: '3px solid #f44336',
    background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
    color: '#c62828',
    boxShadow: '0 0 0 4px rgba(244, 67, 54, 0.15)',
  },
  propositionsContainer: {
    background: 'white',
    padding: '20px',
    borderRadius: '12px',
    border: '2px solid #e0e7ff',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
  },
  propositionsTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1976d2',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderBottom: '2px solid #e0e7ff',
    paddingBottom: '10px',
  },
  propositionsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    overflowY: 'auto',
    maxHeight: '200px',
    paddingRight: '8px',
    justifyContent: 'center',
  },
  draggableItem: {
    padding: '12px 18px',
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    border: '2px solid #1976d2',
    borderRadius: '10px',
    cursor: 'grab',
    fontSize: '14px',
    textAlign: 'center',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)',
    fontWeight: '600',
    color: '#1976d2',
    minWidth: '140px',
    whiteSpace: 'nowrap',
  },
  draggableItemHover: {
    transform: 'translateY(-3px)',
    boxShadow: '0 6px 20px rgba(25, 118, 210, 0.3)',
    borderColor: '#1565c0',
  },
  draggableItemUsed: {
    opacity: 0.4,
    cursor: 'not-allowed',
    background: '#f5f5f5',
    transform: 'scale(0.98)',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginTop: '20px',
  },
  button: {
    padding: '12px 28px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
  },
  buttonDanger: {
    background: 'linear-gradient(135deg, #f44336 0%, #e91e63 100%)',
    color: 'white',
  },
  scoreDisplay: {
    marginTop: '20px',
    padding: '18px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '12px',
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: '700',
    color: 'white',
    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.3)',
  },
  correctIcon: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    background: '#4caf50',
    color: 'white',
    textAlign: 'center',
    lineHeight: '20px',
    fontSize: '11px',
    fontWeight: 'bold',
    position: 'absolute',
    right: '6px',
    top: '6px',
  },
  incorrectIcon: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    background: '#f44336',
    color: 'white',
    textAlign: 'center',
    lineHeight: '20px',
    fontSize: '11px',
    fontWeight: 'bold',
    position: 'absolute',
    right: '6px',
    top: '6px',
  },
  correctAnswerBox: {
    marginTop: '6px',
    padding: '6px 10px',
    background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
    border: '2px solid #4caf50',
    borderRadius: '6px',
    fontSize: '11px',
    color: '#2e7d32',
    fontWeight: '600',
    textAlign: 'center',
  },
};

// ==================== COMPOSANT DRAGGABLE ====================
const DraggableProposition = ({ id, content, isUsed }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id,
    disabled: isUsed,
  });

  const style = {
    ...styles.draggableItem,
    ...(isUsed ? styles.draggableItemUsed : {}),
    ...(isHovered && !isUsed ? styles.draggableItemHover : {}),
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.5 : 1,
    cursor: isUsed ? 'not-allowed' : (isDragging ? 'grabbing' : 'grab'),
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isUsed && <span style={{ marginRight: '8px', color: '#4caf50' }}>✓</span>}
      💡 {content}
    </div>
  );
};

// ==================== COMPOSANT DROP ZONE COMPACT ====================
const DropZoneCompact = ({ id, label, filledWith, correctAnswer, isCorrect, showAnswers }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  let zoneStyle = { ...styles.dropZone };

  if (isOver) {
    zoneStyle = { ...zoneStyle, ...styles.dropZoneActive };
  }

  if (filledWith) {
    zoneStyle = { ...zoneStyle, ...styles.dropZoneFilled };

    if (showAnswers) {
      if (isCorrect) {
        zoneStyle = { ...zoneStyle, ...styles.dropZoneCorrect };
      } else {
        zoneStyle = { ...zoneStyle, ...styles.dropZoneIncorrect };
      }
    }
  }

  return (
    <div style={styles.zoneCard}>
      <div style={styles.zoneLabel}>📍 {label}</div>
      <div>
        <div ref={setNodeRef} style={zoneStyle}>
          {filledWith ? `${filledWith}` : '📥 Glissez ici'}
          {showAnswers && filledWith && (
            <span style={isCorrect ? styles.correctIcon : styles.incorrectIcon}>
              {isCorrect ? '✓' : '✗'}
            </span>
          )}
        </div>

        {showAnswers && !isCorrect && filledWith && (
          <div style={styles.correctAnswerBox}>
            ✓ {correctAnswer}
          </div>
        )}
      </div>
    </div>
  );
};

// ==================== COMPOSANT PRINCIPAL ====================
const DragDropZones = ({
  zones,
  propositions,
  onAnswerChange,
  showCorrectAnswers = false,
  initialFilledZones = {},
}) => {
  const [filledZones, setFilledZones] = useState(initialFilledZones);
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
    document.body.style.cursor = 'grabbing';
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over) {
      const proposition = propositions.find((p) => p.id === active.id);

      setFilledZones((prev) => ({
        ...prev,
        [over.id]: proposition.content,
      }));

      if (onAnswerChange) {
        onAnswerChange({
          zoneId: over.id,
          content: proposition.content,
        });
      }
    }

    document.body.style.cursor = '';
    setActiveId(null);
  };

  const handleReset = () => {
    setFilledZones({});
  };

  const calculateScore = () => {
    let correct = 0;
    zones.forEach((zone) => {
      if (filledZones[zone.id] === zone.correctAnswer) {
        correct++;
      }
    });
    return {
      correct,
      total: zones.length,
      percentage: (correct / zones.length) * 100,
    };
  };

  const usedPropositions = Object.values(filledZones);
  const score = calculateScore();
  const activeProposition = propositions.find((p) => p.id === activeId);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h3 style={styles.title}>🎯 Question de correspondance</h3>
        <p style={styles.instruction}>
          📌 Glissez les propositions du haut vers les zones du bas
        </p>
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        <div style={styles.mainLayout}>
          {/* ✅ 1. PROPOSITIONS DISPONIBLES (EN HAUT, HORIZONTAL) */}
          <div style={styles.propositionsContainer}>
            <div style={styles.propositionsTitle}>
              <span>🎲</span>
              <span>Propositions disponibles</span>
            </div>

            <div style={styles.propositionsGrid}>
              {propositions.map((prop) => (
                <DraggableProposition
                  key={prop.id}
                  id={prop.id}
                  content={prop.content}
                  isUsed={usedPropositions.includes(prop.content)}
                />
              ))}
            </div>
          </div>

          {/* ✅ 2. ZONES À REMPLIR (EN BAS, COMPACTES) */}
          <div style={styles.zonesContainer}>
            <div style={styles.zonesTitle}>
              <span>🎯</span>
              <span>Zones à remplir</span>
            </div>

            <div style={styles.zonesGrid}>
              {zones.map((zone) => (
                <DropZoneCompact
                  key={zone.id}
                  id={zone.id}
                  label={zone.label}
                  filledWith={filledZones[zone.id]}
                  correctAnswer={zone.correctAnswer}
                  isCorrect={filledZones[zone.id] === zone.correctAnswer}
                  showAnswers={showCorrectAnswers}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Portal pour le DragOverlay */}
        {createPortal(
          <DragOverlay dropAnimation={null}>
            {activeProposition ? (
              <div style={{
                ...styles.draggableItem,
                cursor: 'grabbing',
                opacity: 0.95,
                transform: 'rotate(2deg)',
                boxShadow: '0 15px 40px rgba(0, 0, 0, 0.4)',
                pointerEvents: 'none',
                zIndex: 99999,
              }}>
                💡 {activeProposition.content}
              </div>
            ) : null}
          </DragOverlay>,
          document.body
        )}
      </DndContext>

      <div style={styles.buttonContainer}>
        <button
          style={{ ...styles.button, ...styles.buttonDanger }}
          onClick={handleReset}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        >
          🔄 Recommencer
        </button>
      </div>

      {showCorrectAnswers && (
        <div style={styles.scoreDisplay}>
          {score.percentage === 100 ? '🎉' : '📊'} Score : {score.correct} / {score.total} ({score.percentage.toFixed(0)}%)
        </div>
      )}
    </div>
  );
};

export default DragDropZones;